import { UsuarioService } from '@account/usuario.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbCalendar, NgbDateStruct, NgbDatepickerConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '@shared/shared.service';
import { MessageService } from '@shell/message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ModalRechazosComponent } from './modal-rechazos/modal-rechazos.component';
import { EstadoRemitoCargamento } from '@shared/enums/EstadoRemitoCargamento';
import { Transportista } from '@shared/models/stock';
import { RecepcionContingenciaComponent } from '@stock/recepcion-contingencia/recepcion-contingencia.component';
import { DetalleProductosRecepcionComponent } from './detalle-productos-recepcion/detalle-productos-recepcion.component';
import { StockService } from '@stock/stock.service';
import { TanqueService } from '@stock/tanques.service';


@Component({
  selector: 'app-remitos-cargamento',
  templateUrl: './remitos-cargamento.component.html',
  styleUrls: ['./remitos-cargamento.component.scss']
})
export class RemitosCargamentoComponent implements OnInit, OnDestroy {

  modelDesde: NgbDateStruct;
  modelHasta: NgbDateStruct;
  fechaDesde: Date;
  fechaHasta: Date;

  busquedaFormControl = new FormControl();
  remitos: any[] = [];
  remitosFiltrados: any[] = [];
  loading: boolean = false;
  proccess: boolean = false;
  change$: Subscription;

  cargandoTransportistas: boolean;
  errorTransportistas: boolean;
  filtrosHabilitados = false;

  EstadoRemitoCargamento = EstadoRemitoCargamento;

  estados = [
    { nombre: "Pendiente", seleccionado: true, value: EstadoRemitoCargamento.Pendiente },
    { nombre: "Rechazado", seleccionado: false, value: EstadoRemitoCargamento.Rechazado },
  ];

  transportistas = [];

  constructor(private calendar: NgbCalendar,
    private modal: NgbModal,
    private datepickerConfig: NgbDatepickerConfig,
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
    private usuarioService: UsuarioService,
    private tanqueService: TanqueService,
    private sharedService: SharedService,
    private stockService: StockService) {
    this.change$ = sharedService.aeroplantaSeleccionada.subscribe(() => {
      this.cambiarDeAeroplanta()
    })
  }

  toggleDatepicker(e: any) {
    e.toggle();
  }

  cambiarDeAeroplanta() {
    this.ngOnInit();
  }

  ngOnInit() {
    this.setearFechas();
    this.datepickerConfig.minDate = { day: 1, month: 1, year: 2019 };
    this.datepickerConfig.maxDate = { day: 31, month: 12, year: 2050 };
    this.obtenerRemitos();
    this.obtenerTransportistas();
  }

  abrirRecepcion(remito: any) {
    this.loading = true;
    this.spinner.show('spinnerLista');

    const aeroplanta = this.usuarioService.getAeroplantaActual();

    this.tanqueService.getTanquesPorAeroplanta(aeroplanta.codigoAeroplanta).subscribe({
      next: (tanques) => {
        const tanquesActivos = (tanques || []).filter(t => t.activo);

        const tanquesPorProducto: Record<string, any[]> = {};
        for (const t of tanquesActivos) {
          const cod = t?.productoActual?.codigoProducto;
          if (!cod) continue;
          if (!tanquesPorProducto[cod]) tanquesPorProducto[cod] = [];
          tanquesPorProducto[cod].push(t);
        }
        this.loading = false;
        this.spinner.hide('spinnerLista');

        const modalRef = this.modal.open(RecepcionContingenciaComponent, {
          centered: true,
          size: 'xl',
          backdrop: 'static',
          keyboard: false
        });
        modalRef.componentInstance.listado = true;
        modalRef.componentInstance.recepcionCenit = remito;
        modalRef.componentInstance.productos = remito.detalleProductos;
        modalRef.componentInstance.tanques = tanquesActivos;
        (modalRef.componentInstance as any).tanquesPorProducto = tanquesPorProducto;

        modalRef.result
          .then(() => {
            this.obtenerRemitos();
          })
          .catch(() => {
            this.obtenerRemitos();
          });
      },
      error: (err) => {
        console.error('Error al cargar tanques:', err);
        this.loading = false;
        this.spinner.hide('spinnerLista');
        this.messageService.showErrorMessage('Ocurrió un error al cargar los tanques de la aeroplanta.');
      }
    });
  }


  obtenerRemitos() {
    this.spinner.show('spinnerLista');

    const payload = {
      codigoAeroplanta: this.getCodigoAeroplanta(),
      fechaDesde: this.formatDate(
        this.modelDesde.year,
        this.modelDesde.month,
        this.modelDesde.day,
        0,
        0
      ),
      fechaHasta: this.formatDate(
        this.modelHasta.year,
        this.modelHasta.month,
        this.modelHasta.day,
        23,
        59
      ),
      estados: this.estados.filter(e => e.seleccionado).map(e => e.value)
    };

    this.loading = true;
    this.remitos = [];

    this.stockService.obtenerRemitosCargamento(payload).subscribe({
      next: (remitos) => {
        this.remitos = remitos.map(r => ({
          ...r,
          prefijoRemitoCargamento: r.prefijo,
          numeroRemitoCargamento: r.numeroRemito,
          detalleProductos: r.detalles,
          detalleCamion: r.detalleCamionDTO,
          estadoRemito: r.estado
        }));

        this.remitosFiltrados = this.remitos;
        this.loading = false;
        this.spinner.hide('spinnerLista');

        this.aplicarFiltros();
      },
      error: (err) => {
        console.error('Error al obtener remitos:', err);
        this.loading = false;
        this.spinner.hide('spinnerLista');
        this.messageService.showErrorMessage('Ocurrió un error al obtener los remitos de cargamento.');
      }
    });
  }


  aplicarFiltros() {
    const texto = (this.busquedaFormControl.value || '').toString().trim().toLowerCase();

    const seleccionados = this.transportistas
      .filter(t => t.seleccionado)
      .map(t => t.cuit);

    this.remitosFiltrados = this.remitos.filter(r => {
      const pasaTexto = !texto || (
        r.prefijo?.toString().toLowerCase().includes(texto) ||
        r.numeroRemito?.toString().toLowerCase().includes(texto) ||
        r.terminal?.nombre?.toLowerCase().includes(texto)
      );

      const pasaTransportista =
        seleccionados.length === 0 ||
        seleccionados.includes(r.detalleCamionDTO?.cuitTransportista);

      return pasaTexto && pasaTransportista;
    });
  }



  obtenerTransportistas() {
    this.cargandoTransportistas = true;
    this.stockService.getTransportistas()
      .subscribe({
        next: (transportistas) => {
          this.transportistas = transportistas.map(a => Object.assign(new Transportista(), a));
          this.cargandoTransportistas = false;
        },
        error: () => {
          this.errorTransportistas = true;
          this.cargandoTransportistas = false;
        }
      });
  }

  ngOnDestroy() {
    this.change$.unsubscribe();
  }
  setearFechas() {
    const hoy = this.calendar.getToday();

    const fechaHoy = new Date(hoy.year, hoy.month - 1, hoy.day);

    const fechaDesde = new Date(fechaHoy);

    this.modelDesde = {
      year: fechaDesde.getFullYear(),
      month: fechaDesde.getMonth() + 1,
      day: fechaDesde.getDate()
    };

    this.modelHasta = {
      year: fechaHoy.getFullYear(),
      month: fechaHoy.getMonth() + 1,
      day: fechaHoy.getDate()
    };

    this.onModelDesdeChange(this.modelDesde);
    this.onModelHastaChange(this.modelHasta);
  }

  getCodigoAeroplanta() {
    return this.usuarioService.getAeroplantaActual().codigoAeroplanta;
  }
  onModelDesdeChange(date: NgbDateStruct) {
    if (!date) return;
    this.modelDesde = date;
    this.fechaDesde = new Date(date.year, date.month - 1, date.day, 0, 0, 0);
  }

  onModelHastaChange(date: NgbDateStruct) {
    if (!date) return;
    this.modelHasta = date;
    this.fechaHasta = new Date(date.year, date.month - 1, date.day, 23, 59, 59);
  }

  formatDate(year, month, day, hour, minute): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':00';
  }

  rechazarRemito(remito) {
    this.proccess = true;
    const modalRef = this.modal.open(ModalRechazosComponent, { size: 'lg' });
    modalRef.componentInstance.remito = remito;
    modalRef.result
      .then(() => {
        this.messageService.showSuccessMessage('Remito rechazado con éxito');
        this.obtenerRemitos();
      })
      .finally(() => {
        this.proccess = false;
      });
  }

  abrirDetalle(remito) {
    const modalRef = this.modal.open(DetalleProductosRecepcionComponent, { size: 'lg' });
    modalRef.componentInstance.remito = remito;
  }

}
